import React from 'react';
import { ArrowRightIcon, ArrowLeftIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function AccountingHero() {
  return <section className="relative pt-16 pb-24 overflow-hidden bg-white" data-id="element-388">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-389">
        <a href="#/features" className="inline-flex items-center gap-2 text-sm font-semibold text-slate-500 hover:text-slate-900 transition-colors mb-8" data-id="element-390">
          <ArrowLeftIcon className="w-4 h-4" data-id="element-391" /> All features
        </a>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="max-w-4xl mx-auto text-center" data-id="element-392">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-blue-100 text-blue-700 font-semibold text-sm mb-6" data-id="element-393">
            ✨ Accounting business intelligence
          </div>

          <h1 className="font-bold tracking-tight text-slate-900 mb-8" data-id="element-394">
            <div className="text-5xl sm:text-6xl lg:text-7xl leading-[1.05] mb-4" data-id="element-395">
              Accounting database
            </div>
            <div className="text-3xl sm:text-4xl lg:text-5xl leading-tight text-blue-600" data-id="element-396">
              Verified owner contacts & email list
            </div>
          </h1>

          <p className="text-lg sm:text-xl text-slate-600 mb-8 max-w-3xl mx-auto leading-relaxed" data-id="element-397">
            Access the most comprehensive database of accounting firms in the
            US. Get verified accounting owner contacts, verified email lists,
            and verified phone numbers for 250K+ CPAs, tax preparers, and
            bookkeepers.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 mb-10 justify-center" data-id="element-398">
            <a href="http://app.openmart.com/register" target="_blank" rel="noopener noreferrer" className="px-10 py-4 text-white font-bold bg-blue-600 rounded-full hover:bg-blue-700 transition-colors text-lg text-center flex items-center justify-center gap-2" data-id="element-399">
              Try for free <ArrowRightIcon className="w-5 h-5" data-id="element-400" />
            </a>
          </div>

          {/* Stats Bar with Counter Animation */}
          <div className="flex flex-wrap gap-8 md:gap-12 pt-8 justify-center" data-id="element-401">
            <motion.div initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.2,
            duration: 0.5
          }} data-id="element-402">
              <div className="text-3xl font-bold text-blue-600 mb-1" data-id="element-403">250K+</div>
              <div className="text-sm text-slate-500 font-medium" data-id="element-404">
                US accounting firms
              </div>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.3,
            duration: 0.5
          }} data-id="element-405">
              <div className="text-3xl font-bold text-blue-600 mb-1" data-id="element-406">97%</div>
              <div className="text-sm text-slate-500 font-medium" data-id="element-407">
                Verified accuracy
              </div>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.4,
            duration: 0.5
          }} data-id="element-408">
              <div className="text-3xl font-bold text-blue-600 mb-1" data-id="element-409">30+</div>
              <div className="text-sm text-slate-500 font-medium" data-id="element-410">
                Data points
              </div>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.5,
            duration: 0.5
          }} data-id="element-411">
              <div className="text-3xl font-bold text-blue-600 mb-1" data-id="element-412">
                Weekly
              </div>
              <div className="text-sm text-slate-500 font-medium" data-id="element-413">Updates</div>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>;
}